import type { Dict } from '../../i18n';

const dict: Dict = {
  en: {
    heading: 'Reassign clients',
    subtitle: 'Move an agent’s clients to another agent',
    fromAgent: 'From agent',
    toAgent: 'To agent',
    selectAgent: 'Select an agent…',
    selection: 'Which clients',
    modeAll: 'All clients of the agent',
    modeProvince: 'By province',
    modeCity: 'By city',
    modeRecent: 'With orders in the last {{months}} months',
    modeIds: 'One by one (tick in the preview)',
    valueProvince: 'Province',
    valueCity: 'City',
    previewBtn: 'Preview',
    previewLoading: 'Loading preview…',
    previewEmpty: 'No clients match this selection.',
    previewCount_one: '{{count}} client will be reassigned',
    previewCount_other: '{{count}} clients will be reassigned',
    colClient: 'Client',
    colCity: 'City',
    colProvince: 'Province',
    colLastOrder: 'Last order',
    colOpenOrders: 'Open orders',
    openOrdersHint: 'Open orders and their commission stay with the current agent; only the client record moves.',
    confirmBtn: 'Reassign {{count}} clients',
    confirmDialog: 'Reassign {{count}} clients from {{from}} to {{to}}?',
    done: '{{count}} clients reassigned to {{to}}.',
    backBtn: 'Back to clients',
    sameAgent: 'Choose a different target agent.',
  },
  es: {
    heading: 'Reasignar clientes',
    subtitle: 'Pasar los clientes de un agente a otro',
    fromAgent: 'De agente',
    toAgent: 'A agente',
    selectAgent: 'Selecciona un agente…',
    selection: 'Qué clientes',
    modeAll: 'Todos los clientes del agente',
    modeProvince: 'Por provincia',
    modeCity: 'Por ciudad',
    modeRecent: 'Con pedidos en los últimos {{months}} meses',
    modeIds: 'Uno a uno (marcar en la vista previa)',
    valueProvince: 'Provincia',
    valueCity: 'Ciudad',
    previewBtn: 'Vista previa',
    previewLoading: 'Cargando vista previa…',
    previewEmpty: 'Ningún cliente coincide con esta selección.',
    previewCount_one: 'Se reasignará {{count}} cliente',
    previewCount_other: 'Se reasignarán {{count}} clientes',
    colClient: 'Cliente',
    colCity: 'Ciudad',
    colProvince: 'Provincia',
    colLastOrder: 'Último pedido',
    colOpenOrders: 'Pedidos abiertos',
    openOrdersHint: 'Los pedidos abiertos y su comisión se quedan con el agente actual; solo se mueve la ficha del cliente.',
    confirmBtn: 'Reasignar {{count}} clientes',
    confirmDialog: '¿Reasignar {{count}} clientes de {{from}} a {{to}}?',
    done: '{{count}} clientes reasignados a {{to}}.',
    backBtn: 'Volver a clientes',
    sameAgent: 'Elige un agente de destino distinto.',
  },
  de: {
    heading: 'Kunden neu zuweisen',
    subtitle: 'Kunden eines Agenten an einen anderen Agenten übergeben',
    fromAgent: 'Von Agent',
    toAgent: 'An Agent',
    selectAgent: 'Agent auswählen…',
    selection: 'Welche Kunden',
    modeAll: 'Alle Kunden des Agenten',
    modeProvince: 'Nach Provinz',
    modeCity: 'Nach Stadt',
    modeRecent: 'Mit Aufträgen in den letzten {{months}} Monaten',
    modeIds: 'Einzeln (in der Vorschau anhaken)',
    valueProvince: 'Provinz',
    valueCity: 'Stadt',
    previewBtn: 'Vorschau',
    previewLoading: 'Vorschau wird geladen…',
    previewEmpty: 'Keine Kunden entsprechen dieser Auswahl.',
    previewCount_one: '{{count}} Kunde wird neu zugewiesen',
    previewCount_other: '{{count}} Kunden werden neu zugewiesen',
    colClient: 'Kunde',
    colCity: 'Stadt',
    colProvince: 'Provinz',
    colLastOrder: 'Letzter Auftrag',
    colOpenOrders: 'Offene Aufträge',
    openOrdersHint: 'Offene Aufträge und ihre Provision bleiben beim bisherigen Agenten; nur der Kundendatensatz wechselt.',
    confirmBtn: '{{count}} Kunden neu zuweisen',
    confirmDialog: '{{count}} Kunden von {{from}} an {{to}} neu zuweisen?',
    done: '{{count}} Kunden an {{to}} neu zugewiesen.',
    backBtn: 'Zurück zu den Kunden',
    sameAgent: 'Wählen Sie einen anderen Zielagenten.',
  },
};

export default dict;
